/*
 * @Author: edvardchen
 * @Date:   2016-12-07 16:10:30
 * @Last Modified by: edvardchen
 * @Last Modified time: 2018-03-20 23:12:07
 */

// @flow
import _ from 'lodash';
import { listen } from 'fbjs/lib/EventListener';

let hidden;
let visibilityChange;
if (typeof document.hidden !== 'undefined') {
  hidden = 'hidden';
  visibilityChange = 'visibilitychange';
} else if (typeof document.webkitHidden !== 'undefined') {
  hidden = 'webkitHidden';
  visibilityChange = 'webkitvisibilitychange';
}

const DELAY = 300;
const onVisibilityChange = (fn: Function) => {
  const doc: Object = document;
  const handle = _.throttle((event) => {
    fn(event, doc[hidden]);
  }, DELAY);
  return listen(document, visibilityChange, handle);
};

export default onVisibilityChange;
